import React from 'react';
import classnames from 'classnames';
import includes from "lodash/includes";
import get from "lodash/get";

const CarouselArrows = ({ onClick, direction = 'left', isHidden, additionalClassName = '', gradientBackground = false, ...props }) => {
  const buttonClass = classnames(`btn no-gutter remove-click-styling CarouselButton ${direction} ${additionalClassName}`, {
    hidden: isHidden || includes(get(props, 'className', ''), 'slick-disabled'),
    noOutline: props.noOutline
  });
  return (
    <>
    <button
      className={buttonClass}
      onClick={onClick}
    >
      <i className="icon-image-arrows" />
    </button>
    </>
  );
};

export default CarouselArrows;
